/*
 * @author        jordan.sookikian@zumper.com (Jordan Sookikian)
 * @copyright     Copyright (c) 2022, Zumper
 * @description   EngrainFeatureRoot.tsx
 */

import { EngrainFeatureRoot } from '@zcode-ui/web-zumper-features'
import type { Building } from '@zcode/state-type'
import React from 'react'

import { EngrainMessageBarLoadable } from './EngrainMessageBarLoadable'

export interface EngrainPropertyMapProps {
  building: Building
  isOpen: boolean
  onOpen: () => void
  onClose: () => void
}

export const EngrainPropertyMap = ({
  building,
  isOpen,
  onOpen,
  onClose,
}: EngrainPropertyMapProps) => {
  return (
    <EngrainFeatureRoot
      MessageBar={EngrainMessageBarLoadable}
      building={building}
      isOpen={isOpen}
      onClose={onClose}
      onOpen={onOpen}
    />
  )
}
